const SET_IMMUNIZATIONS = 'immunizations//SET_IMMUNIZATIONS'
const REMOVE_IMMUNIZATIONS = 'immunizations//REMOVE_IMMUNIZATIONS'
const ADD_IMMUNIZATION = 'immunizations//ADD_IMMUNIZATION'

export {
  REMOVE_IMMUNIZATIONS,
  SET_IMMUNIZATIONS,
  ADD_IMMUNIZATION
}
